import React, { useEffect, useState } from "react";
import { Table, Tag, Button, Row, Col, Space, Input, Select, Tooltip, Pagination } from "antd";
import { EyeOutlined, SearchOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { appointmentService } from "../../../services";
import dayjs from "dayjs";
import { ROLES } from "../../../constants";
import { changeDocumentTitle } from "../../../utils/title";

function Appointments() {
  const role = localStorage.getItem('role')
  const [search, setSearch] = useState(null)
  const [loading, setLoading] = useState(false);
  const [appointments, setAppointments] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    total: 0,
    pageSize: 10,
  });

  const options = [
    {
      value: "10",
      label: "10",
    },
    {
      value: "25",
      label: "25",
    },
    {
      value: "50",
      label: "50",
    },
  ];

  const columns = [
    {
      title: "Id",
      dataIndex: "id",
      key: "id",
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (text) => text.split(" ").map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(" ")
    },
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
      render: (date) => dayjs(date).format("DD, MMM-YYYY"),
    },
    {
      title: "Time",
      dataIndex: "time",
      key: "time",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status, record) => {
        const { approved, reject, pending } = record;
        // Conditionally render tags based on the status
        return (
          <Space>
            {status === 2 && (
              // If status is 2, show "Canceled"
              <Tag
                color="#F04949"
                style={{ fontSize: "12px", padding: "5px 5px" }}
              >
                Canceled
              </Tag>
            )}
            {/* // Otherwise, show Approved, Reject, and Pending based on their
            counts */}
            <>
              {approved > 0 && (
                <Tag
                  color="#06D652"
                  style={{ fontSize: "12px", padding: "5px 5px" }}
                >
                  Approved ({approved})
                </Tag>
              )}
              {reject > 0 && (
                <Tag
                  color="#B83D3D"
                  style={{ fontSize: "12px", padding: "5px 5px" }}
                >
                  Reject ({reject})
                </Tag>
              )}
              {pending > 0 && (
                <Tag
                  color="#D68606"
                  style={{ fontSize: "12px", padding: "5px 5px" }}
                >
                  Pending ({pending})
                </Tag>
              )}
            </>
          </Space>
        );
      },
    },
    {
      title: "Actions",
      key: "Actions",
      render: (text, record) => (
        <Link to={role === ROLES.CUSTOMER ? `/appointments/view/${record.id}` : `/operations/appointment/view/${record.id}`} className="hover:text-primary">
          <Tooltip title='View'>
            <EyeOutlined />
          </Tooltip>
        </Link>
      ),
    },
  ];

  const initialize = async (page = 1, pageSize = pagination.pageSize, search = null) => {
    setLoading(true);
    const { success, data } = await appointmentService.fetch(page, pageSize, search);
    if (success) {
      setAppointments(data.data);
      setPagination((prev) => ({
        ...prev,
        total: data.total,
        current: page,
        pageSize,
      }));
    }
    setLoading(false);
  };


  useEffect(() => {
    changeDocumentTitle("Appointments");
    initialize(pagination.current, pagination.pageSize, search);
  }, [search]);

  return (
    <div
      style={{
        padding: "5px",
        border: "1px solid #ccc",
        borderRadius: "8px",
        backgroundColor: "#FFFFFF",
      }}
    >

      <div className="flex justify-between items-center">
        <h1 style={{ fontWeight: "bold" }} className="pl-2 pt-3">
          Appointments
        </h1>
        <Input
          placeholder="Search by Name"
          prefix={<SearchOutlined />}
          style={{
            width: "25%",
            borderRadius: "20px",
            fontSize: 14,
            margin: 10
          }}
          onChange={(e) => {
            setSearch(e.target.value)
          }}
        />
      </div>

      <Table
        columns={columns}
        scroll={{ x: "max-content" }}
        dataSource={appointments}
        rowKey="id"
        style={{ marginTop: "10px" }}
        loading={loading}
        pagination={false}
        footer={() => (
          <div className="flex justify-between items-center text-xs ">
            <div className=" text-gray-600">
              Showing {(pagination.current - 1) * pagination.pageSize + 1} to{" "}
              {Math.min(pagination.current * pagination.pageSize, pagination.total)} of{" "}
              {pagination.total} entries
            </div>
            <Pagination
              current={pagination.current}
              total={pagination.total}
              pageSize={pagination.pageSize}
              showSizeChanger={false}
              onChange={(page) => initialize(page, pagination.pageSize, search)}
              itemRender={(current, type, originalElement) => {
                if (type === "prev") return <a className="bg-[#EEEEEE] p-2 rounded-sm hover:text-primary">Previous</a>;
                if (type === "next") return <a className="bg-[#EEEEEE] p-2 rounded-sm hover:text-primary">Next</a>;
                return originalElement;
              }}
            />
          </div>
        )}
      />
    </div>
  );
}

export default Appointments;
